export default {
  title: {
    welcome: 'Velkomstbonusbillede',
    app_signup: 'Bonusbillede til tilmelding i mobilappen',
  },
  select: {
    generate_title: 'Generer et billede med AI',
    generate_subtitle: 'Vi laver et ud fra dit cashback-program.',
    generate_cta: 'Generer',
    upload_link: 'eller upload fra din enhed',
    rate_limit_company: {
      title: 'Vi har brug for et øjeblik',
      description: 'Din restaurant har genereret mange billeder i denne time. Prøv igen om {{time}}.',
    },
    rate_limit_cashback_bonus: {
      title: 'Lige en lille pause',
      description: 'Det ser ud til, at du har prøvet denne bonus flere gange i træk. Vi er klar igen om {{time}}.',
    },
  },
  generating: {
    title: 'Genererer dit billede…',
    progress: {
      cooking: 'Vi laver noget lækkert…',
      plating: 'Anretter…',
      finishing: 'Tilføjer de sidste detaljer…',
    },
  },
  preview: {
    alt: 'Genereret bonusbillede',
    hint: 'Ikke helt rigtigt? Generer igen, eller fortsæt for at beskære billedet.',
    click_to_expand: 'Klik for at forstørre',
    regenerate: 'Generer igen',
    continue: 'Fortsæt til redigering',
  },
  toasts: {
    upload_success: 'Billedet er uploadet.',
    upload_failed: 'Billedet kunne ikke uploades.',
    delete_success: 'Billedet er slettet.',
    delete_failed: 'Billedet kunne ikke slettes.',
    generate_success: 'Billedet er genereret.',
    generate_failed: 'Billedgenereringen kunne ikke startes.',
    generate_timeout: 'Billedet genereres stadig. Det vises her, når det er klar.',
    rate_limit_company: 'Timegrænsen for billeder er nået for denne restaurant. Prøv igen om {{time}}.',
    rate_limit_cashback_bonus: 'Lidt for mange forsøg med denne bonus lige nu – prøv igen om {{time}}.',
  },
  time: {
    seconds_one: '1 sekund',
    seconds_other: '{{count}} sekunder',
    minutes_one: '1 minut',
    minutes_other: '{{count}} minutter',
    hours_one: '1 time',
    hours_other: '{{count}} timer',
  },
};
